// eslint-disable-next-line no-shadow
export enum TodoCondition {
  Neutral = 'Neutral',
  Saving = 'Saving',
  Deleting = 'Deleting',
}
